/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export { ShiftSwitch } from "./ShiftSwitch";